import { Link } from "react-router-dom";
import { MapPin, ShieldCheck } from "lucide-react";
import { CITIES, SERVICES, REGIONS, citiesByRegion, PHONE, PHONE_HREF, EMAIL, EMAIL_HREF } from "@/data";
import { INSIGHTS } from "@/data/insights";

const Footer = () => (
  <footer className="border-t border-[#1C2027] bg-[#07090D]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center bg-[#F5A800]">
              <svg viewBox="0 0 64 64" className="h-5 w-5" aria-hidden="true">
                <path d="M18 8 L32 26 L46 8 L58 8 L39 32 L58 56 L46 56 L32 38 L18 56 L6 56 L25 32 L6 8 Z" fill="#0A0C10" />
              </svg>
            </span>
            <span className="leading-none">
              <span className="font-condensed block text-xl font-bold uppercase tracking-wide text-white">Xtreme Protection</span>
              <span className="block text-[10px] font-semibold uppercase tracking-[0.28em] text-[#F5A800]">Wales Security Services</span>
            </span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#9BA1AB]">
            SIA-licensed security guard services across Wales — manned guarding, mobile patrols, CCTV monitoring, door supervision and 14 more specialist services, delivered 24/7 from local Welsh teams.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href={PHONE_HREF} data-testid="footer-phone-link" className="block font-semibold text-[#F5A800] hover:text-white">{PHONE}</a>
            <a href={EMAIL_HREF} data-testid="footer-email-link" className="block font-semibold text-[#F5A800] hover:text-white">{EMAIL}</a>
          </div>
          <div className="mt-6 flex flex-wrap gap-2">
            {["SIA Licensed", "BS 7858 Vetted", "24/7 Command", "First-Aid Trained"].map((b) => (
              <span key={b} className="flex items-center gap-1.5 border border-[#1C2027] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-white/60">
                <ShieldCheck className="h-3 w-3 text-[#F5A800]" />
                {b}
              </span>
            ))}
          </div>
        </div>
        <div className="grid gap-10 sm:grid-cols-2">
          <div>
            <h3 className="font-condensed text-lg font-bold uppercase tracking-wide text-white">Security Services Wales</h3>
            <ul className="mt-4 space-y-2">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-[13px] text-[#9BA1AB] transition-colors duration-200 hover:text-[#F5A800]">
                    {s.name} Wales
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="font-condensed mt-8 text-lg font-bold uppercase tracking-wide text-white">Security Insights</h3>
            <ul className="mt-4 space-y-2">
              {INSIGHTS.slice(0, 5).map((a) => (
                <li key={a.slug}>
                  <Link to={`/insights/${a.slug}`} data-testid={`footer-insight-${a.slug}`} className="text-[13px] text-[#9BA1AB] transition-colors duration-200 hover:text-[#F5A800]">
                    {a.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-condensed text-lg font-bold uppercase tracking-wide text-white">Wales Locations</h3>
            {REGIONS.map((r) => (
              <div key={r} className="mt-4">
                <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#F5A800]/70">{r}</p>
                <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-1.5">
                  {citiesByRegion(r).map((c) => (
                    <li key={c.slug}>
                      <Link to={`/locations/${c.slug}`} data-testid={`footer-city-${c.slug}`} className="text-[13px] text-[#9BA1AB] transition-colors duration-200 hover:text-[#F5A800]">
                        Security {c.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-[#1C2027] pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-[11px] uppercase tracking-[0.2em] text-white/40">© 2026 Xtreme Protection — Wales Security Guard Services</p>
        <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-white/40">
          <MapPin className="h-3 w-3 text-[#F5A800]" />
          North Wales · South Wales · Mid Wales · West Wales
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
